/**
 * Reads cookie value from document.cookie
 * @param key
 * @returns
 */
export function getCookieValue(key: string) {
  const cookies = document.cookie.split(';');
  for (let i = 0; i < cookies.length; i++) {
    let cookie = cookies[i];
    while (cookie.charAt(0) === ' ') {
      cookie = cookie.substring(1);
    }
    if (cookie.indexOf(key + '=') === 0) {
      return cookie.substring(key.length + 1, cookie.length);
    }
  }
  return '';
}
